module.exports = __webpack_public_path__ + "img/slider-image-02-insanon.2d2b0300.png";